// src/i18n/en.js

const en = {
    // ── Header & Hero ────────────────────────────────────────────
    headerPlaceholder: 'Transaction ID / Order ID',
    heroSubtitle:      'Search Transaction or Order',
    authComingSoon:    'Authorization will be available soon.',

    heroTitle:         'Search Transaction or Order',

    // ── OrderCard ────────────────────────────────────────────────
    amount:       'Amount',
    sender:       'Sender',
    receiver:     'Receiver',
    description:  'Description',
    feeSend:      'Fee paid by receiver',
    feeGet:       'Fee paid by sender',
    linkedOrder:  'Order',
    pay:          'Pay',

    // ── SearchOrder ──────────────────────────────────────────────
    searchTitle:       'Search Order',
    searchPlaceholder: 'Enter order number',
    searchButton:      'Search',
    searchNotFound:    'Order not found or not in the active list.',

    // ── PayWidget ────────────────────────────────────────────────
    payTitle:    'Order payment',
    payButton:   'Pay',
    paySuccess:  'Payment successful',
    payError:    'Payment error',

    // ── Common ───────────────────────────────────────────────────
    loading: 'Loading...',
    error:   'Error',
    close:   'Close',
    noData:  '—',
};

export default en;
